import { render, staticRenderFns } from "./SurveyItemTable.vue?vue&type=template&id=face9222&"
import script from "./SurveyItemTable.vue?vue&type=script&lang=ts&"
export * from "./SurveyItemTable.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyItemTable.vue?vue&type=style&index=0&id=face9222&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports